const TOAST_OPTIONS = {
  autoClose: 5000,
};

export default TOAST_OPTIONS;
